(function (doc, win, pwidth, prem) {
    var docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function () {
            var clientWidth = docEl.clientWidth;
            console.log(clientWidth)
            if (!clientWidth) return;
            docEl.style.fontSize = prem * (clientWidth / pwidth) + 'px';
        };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window, 375, 100);